<bit-card class="tw-mt-16 tw-block !tw-border-danger-soft tw-overflow-hidden">
  <div
    class="-tw-m-4 tw-mb-4 [@media(min-width:769px)]:-tw-m-6 [@media(min-width:769px)]:tw-mb-4 tw-flex tw-items-center tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-danger-soft tw-bg-danger-soft tw-px-4 tw-py-3 [@media(min-width:769px)]:tw-px-6"
  >
    <i class="bwi bwi-exclamation-triangle tw-text-fg-danger" aria-hidden="true"></i>
    <h2 bitTypography="h4" class="!tw-mb-0 !tw-text-fg-danger">{{ "dangerZone" | i18n }}</h2>
  </div>
  <div
    #content
    class="tw-grid tw-auto-rows-fr @2xl:tw-grid-cols-2 @3xl:tw-flex tw-gap-2 @2xl:tw-gap-4 @3xl:tw-gap-2"
  >
    <ng-content></ng-content>
  </div>
</bit-card>
